__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/abba95a8402f9aee96e72ecf63df3c69734f5e372298d15d6fa36be7/";